module.exports = __webpack_public_path__ + "static/media/About1.b21ca919.png";